import { Card, Form, Input, Select } from 'antd';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { EcommerceIconComponent } from 'assets/icons/ecommerce';
import { IProduct } from 'interfaces/products';
import { IProductSet } from 'interfaces/product_sets';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm, useSelect } from '@refinedev/antd';

export const ProductSetCreate = () => {
  const { formProps, saveButtonProps } = useForm<IProductSet>();
  const { selectProps } = useSelect<IProduct>({
    resource: 'products',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  return (
    <CreateLayout saveButtonProps={saveButtonProps} title="Criar set">
      <PageHeader title="Criar set" icon={EcommerceIconComponent} />

      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Produtos" name="product_ids">
            <Select {...selectProps} allowClear mode="multiple" />
          </Form.Item>
        </Form>
      </Card>
    </CreateLayout>
  );
};
